module.exports = __webpack_public_path__ + "img/a.8e629ae2.png";